import { Project } from '@brg/api/dist/api-core/types';
import { FlexBox } from '@brg/ui';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { RectangularButtonFilled } from 'shared/components/buttons';
import styled from 'styled-components';

const PurchaseWrapper = styled(FlexBox)`
  margin: 16px 0 24px 0;
  width: 100%;
  // min-width: 300px;
`;

const PurchaseButton = styled(RectangularButtonFilled)`
  max-width: 100%;
  width: 100%;
  background-color: #146DEE;
  height: 46px;
`;

export const ProjectPurchase: FC<{ project: Project, isModer?: boolean }> = ({ project, isModer }) => {
    const { t } = useTranslation();

    const handleClick = useCallback(() => {
        alert(`PURCHASE ID: ${project?.projectId}`)
      }, [project]);

      if (!isModer) {
        return null;
      }

    return (
        <PurchaseWrapper width={'100%'} widthMobile={'100%'} onClick={handleClick}>
            <PurchaseButton fixedSize>{t('project_edit.purchase')}</PurchaseButton>
        </PurchaseWrapper>
    )
}import { Project } from '@brg/api/dist/api-core/types';
import { FlexBox } from '@brg/ui';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { RectangularButtonFilled } from 'shared/components/buttons';
import styled from 'styled-components';

const PurchaseWrapper = styled(FlexBox)`
  margin: 16px 0 24px 0;
  width: 100%;
  // min-width: 300px;
`;

const PurchaseButton = styled(RectangularButtonFilled)`
  max-width: 100%;
  width: 100%;
  background-color: #146DEE;
  height: 46px;
`;

export const ProjectPurchase: FC<{ project: Project, isModer?: boolean }> = ({ project, isModer }) => {
    const { t } = useTranslation();

    const handleClick = useCallback(() => {
        alert(`PURCHASE ID: ${project?.projectId}`)
      }, [project]);

      if (!isModer) {
        return null;
      }

    return (
        <PurchaseWrapper width={'100%'} widthMobile={'100%'} onClick={handleClick}>
            <PurchaseButton fixedSize>{t('project_edit.purchase')}</PurchaseButton>
        </PurchaseWrapper>
    )
}